import React from 'react'
import { LoadingIcon } from '../../assets/icons/icon'
import { cn } from '../../lib/utils'

const buttonVariants = {
  primary:
    "px-6 py-3 bg-primary text-white font-semibold hover:bg-primary/90 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
  outline:
    "px-4 py-2 border border-gray-300 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200",
  secondary:
    "flex justify-center space-x-2 px-4 py-2 text-white transition-colors duration-200 w-full sm:w-auto",
  commonBtn:
    "flex px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200  font-medium transition-colors duration-200",
}
export const CustomButton = ({
  text,
  variant = "",
  className,
  disabled = false,
  isLoading = false,
  children,
  ...props
}) => {
  const baseClasses =
    "flex px-6 py-3 rounded-lg rounded-xl font-medium transition-all duration-300 flex items-center justify-center gap-2";

  const variants = {
    primary:
      "bg-gradient-to-r from-primary to-secondary text-white hover:shadow-lg transform hover:scale-[1.02]",
    secondary:
      "text-gray-700 hover:bg-gray-50 border border-gray-300",
  };

  const disabledClasses =
    "opacity-50 cursor-not-allowed hover:shadow-none hover:scale-100";

  return (
    <button
      {...props}
      disabled={disabled || isLoading}
      className={cn(
        baseClasses,
        variants[variant],
        (disabled || isLoading) && disabledClasses,
        className
      )}
    >
      {isLoading ? (
        <LoadingIcon />
      ) : (children || text)}

    </button>
  );
};


export const ButtonWithIcon = ({ onClick, text, Icon, iconClass, btnclass, variant = "primary", title, disabled, isLoading, revers = false }) => {
  return (
    <button
      onClick={onClick}
      className={cn(`inline-flex items-center rounded-lg disabled:cursor-not-allowed ${revers ? 'flex-row-reverse' : ''}`, buttonVariants[variant], btnclass)}
      title={title}
      disabled={disabled}
    >
      {isLoading ? (
        <>
          <LoadingIcon />
          <span>Processing...</span>
        </>
      ) : (
        <>
          {Icon && <Icon className={cn("mr-2", iconClass)} />}
          {text}
        </>
      )}

    </button>
  )
}